export default __webpack_public_path__ + "static/media/halfcircle-circumference.ae534a91.svg";